import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";
import { Logo } from "@/components/Logo";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav("/login", { replace: true });
      return;
    }
    const sessionId = m[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", null, {
          headers: { "X-Session-ID": sessionId }
        });
        setUser(data.user);
        // Clean hash
        window.history.replaceState(null, "", "/app");
        if (data.needs_onboarding) {
          nav("/app/onboarding", { replace: true });
        } else {
          nav("/app", { replace: true });
        }
      } catch (e) {
        nav("/login", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen bg-[#0A0605] flex flex-col items-center justify-center gap-4">
      <Logo size="lg"/>
      <Loader2 className="animate-spin text-[#DC2626]" />
      <p className="text-zinc-400 text-sm">Signing you in…</p>
    </div>
  );
}
